export const flowplayerToken =
    'eyJraWQiOiJZRjk0UDlMM0phTzUiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NixcImlkXCI6XCJZRjk0UDlMM0phTzVcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.GwJk8dFr3gmm7wBniq0FjDGKq2p6B9OEnYYBKG-roi6SjcF7G8ljbXmEfwwRWDmWNY_3oMJEuun3w-UGUQWb0g';

export const allLanguages: { key: string; name: string; desc: string }[] = [
    { key: 'en', name: 'English', desc: 'English' },
    { key: 'de', name: 'Deutsch', desc: 'German' },
    { key: 'ru', name: 'Русский', desc: 'Russian' },
    { key: 'fr', name: 'Français', desc: 'French' },
    { key: 'es', name: 'Español', desc: 'Spanish' },
    { key: 'pt-br', name: 'Português', desc: 'Portuguese (Brazilian)' },
    { key: 'tr', name: 'Türkçe', desc: 'Turkish' },
    { key: 'it', name: 'Italiano', desc: 'Italian' },
    { key: 'hb', name: 'עִבְרִית', desc: 'Hebrew' },
    { key: 'nl', name: 'Nederlands', desc: 'Dutch' },
    { key: 'ja', name: '日本語', desc: 'Japanese' },
    { key: 'kr', name: '한국어', desc: 'Korean' },
    { key: 'cn', name: '中文', desc: 'Chinese' },
    { key: 'ar', name: 'العربية', desc: 'Arabic' },
    { key: 'hi', name: 'हिंदी', desc: 'Hindi' },
    { key: 'no', name: 'norsk', desc: 'Norwegian' },
    { key: 'sv', name: 'svenska', desc: 'Swedish' },
    { key: 'da', name: 'dansk', desc: 'Danish' },
    { key: 'pl', name: 'Polski', desc: 'Polish' },
];

/** Locale options for chapter quiz library rebuild. Keys match library mapping storage (ko, not kr). */
export const libraryRebuildLocales: { key: string; name: string }[] = [
    { key: 'en', name: 'EN - English' },
    { key: 'cn', name: 'CN - 中文' },
    { key: 'de', name: 'DE - Deutsch' },
    { key: 'es', name: 'ES - Español' },
    { key: 'ko', name: 'KR - 한국어' },
    { key: 'it', name: 'IT - Italiano' },
    { key: 'fr', name: 'FR - Français' },
    { key: 'pt', name: 'PT - Português' },
    { key: 'tr', name: 'TR - Türkçe' },
    { key: 'ja', name: 'JA - 日本語' },
    { key: 'pl', name: 'PL - Polski' },
    { key: 'ru', name: 'RU - Русский' },
    { key: 'he', name: 'HE - עִברִית' },
    { key: 'ar', name: 'AR - العربية' },
    { key: 'nl', name: 'NL - Nederlands' },
];

export const translationApis: { key: string, name: string, default?: boolean|null }[] = [
    { key: 'chatgpt', name: 'ChatGPT', default: true }
]

// export const editorsEmail: { key: string, name: string, default?: boolean|null }[] = [  
//     { key: 'benjaminwerth', name: 'benjamin.werth@jove.com' },
//     { key: 'ethanzhang', name: 'ethan.zhang@jove.com' },
//     { key: 'sourikmondal', name: 'sourik.mondal@jove.com' },
//     { key: 'balamurugankuppan', name: 'balamurugan.kuppan@jove.com' },
//     { key: 'ednageorge', name: 'edna.george@jove.com' },
//     { key: 'shalinisanyal', name: 'shalini.sanyal@jove.com' },
//     { key: 'nupurfangaria', name: 'nupur.fangaria@jove.com' },
//     { key: 'neethuabraham', name: 'neethu.abraham@jove.com' },
//     { key: 'jasmeetsahni', name: 'jasmeet.sahni@jove.com' },
//     { key: 'shivanibhagat', name: 'shivani.bhagat@jove.com' },
//     { key: 'tasaduqwani', name: 'tasaduq.wani@jove.com' },
//     { key: 'adityaroy', name: 'aditya.roy@jove.com' },
//     { key: 'titusthankachan', name: 'titus.thankachan@jove.com' },
//     { key: 'dharasachdev', name: 'dhara.sachdev@jove.com' },
//     { key: 'ashnaali', name: 'ashna.ali@jove.com' },
//     { key: 'keertichauhan', name: 'keerti.chauhan@jove.com' },
//     { key: 'swathikesh', name: 'swathi.kesh@jove.com'},
// ]

export const editorsEmail: { key: string, name: string, default?: boolean | null }[] = [
 { key: 'adityaroy', name: 'aditya.roy@jove.com' },
{ key: 'aishakhan', name: 'aisha.khan@jove.com' },
{ key: 'aishwaryakakade', name: 'aishwarya.kakade@jove.com' },
{ key: 'adrianaperezgrovas', name: 'adriana.perezgrovas@jove.com' },
{ key: 'adrianopontes', name: 'adriano.pontes@jove.com' },
{ key: 'amruthapulagam', name: 'amrutha.pulagam@jove.com' },
{ key: 'arshkhan', name: 'arsh.khan@jove.com' },
{ key: 'ashwijakolakemar', name: 'ashwija.kolakemar@jove.com' },
{ key: 'benjaminwerth', name: 'benjamin.werth@jove.com' },
{ key: 'bhaktikharote', name: 'bhakti.kharote@jove.com' },
{ key: 'camilacshanley', name: 'camila.cshanley@jove.com' },
{ key: 'chaitrabandiwadekar', name: 'chaitra.bandiwadekar@jove.com' },
{ key: 'dharasachdev', name: 'dhara.sachdev@jove.com' },
{ key: 'diptikelkar', name: 'dipti.kelkar@jove.com' },
{ key: 'ednageorge', name: 'edna.george@jove.com' },
{ key: 'ethanzhang', name: 'ethan.zhang@jove.com' },
{ key: 'flaviapetean', name: 'flavia.petean@jove.com' },
{ key: 'hemalipatadia', name: 'hemali.patadia@jove.com' },
{ key: 'jaquelinehersch', name: 'jaqueline.hersch@jove.com' },
{ key: 'keertichauhan', name: 'keerti.chauhan@jove.com' },
{ key: 'luisatacca', name: 'luisa.tacca@jove.com' },
{ key: 'madhurarj', name: 'madhura.rj@jove.com' },
{ key: 'milicamarkovic', name: 'milica.markovic@jove.com' },
{ key: 'neethuabraham', name: 'neethu.abraham@jove.com' },
{ key: 'poojabisht', name: 'pooja.bisht@jove.com' },
{ key: 'pradnyachoukekar', name: 'pradnya.choukekar@jove.com' },
{ key: 'raunaksharma', name: 'raunak.sharma@jove.com' },
{ key: 'saptarshisinha', name: 'saptarshi.sinha@jove.com' },
{ key: 'shivanibhagat', name: 'shivani.bhagat@jove.com' },
{ key: 'songyanzhou', name: 'songyan.zhou@myjove.com' },
{ key: 'sourikmondal', name: 'sourik.mondal@jove.com' },
{ key: 'suhyunjo', name: 'suhyun.jo@jove.com' },
{ key: 'swathikesh', name: 'swathi.kesh@jove.com' },
{ key: 'tasaduqwani', name: 'tasaduq.wani@jove.com' },
{ key: 'titusthankachan', name: 'titus.thankachan@jove.com' },
{ key: 'zhentaouzhong', name: 'zhen-tao.zhong@jove.com' },
{ key: 'basu', name: 'basu.bhattacharjee@jove.com' },
{ key: 'julia', name: 'julia.figueiredo@jove.com' },
{ key: 'beatriz', name: 'beatriz.nielsen@jove.com' },
{ key: 'madhurima', name: 'madhurima.paul@jove.com' },
{ key: 'yuelang', name: 'yuelang.yao@myjove.com' },
{ key: 'camilakehl', name: 'camila.kehl@jove.com' },
{ key: 'taianenepomoceno', name: 'taiane.nepomoceno@jove.com' },
{ key: 'marwasaady', name: 'marwa.saady@jove.com' },
{ key: 'salmaessam', name: 'salma.essam@jove.com' },
{ key: 'erwinpark', name: 'erwin.park@jove.com' },
{ key: 'paulaoblessuc', name: 'paula.oblessuc@jove.com' },
{ key: 'marianademarchi', name: 'mariana.demarchi@jove.com' },
{ key: 'verenashafik', name: 'verena.shafik@jove.com' },
{ key: 'mitchellsun', name: 'mitchell.sun@jove.com' },
{ key: 'yuanwan', name: 'yuan.wan@jove.com' },
].sort((a, b) => a.name.localeCompare(b.name)); 


export const translationApiVer: { key: string, name: string, default?: boolean|null }[] = [
    { key: 'gpt-3.5-turbo-16k', name: 'GPT-3.5 [16k] (Recommended)', default: true },
    { key: 'gpt-4', name: 'GPT-4 [8k]' }
]
